import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { applyMiddleware, compose, createStore, GenericStoreEnhancer } from 'redux';
import thunk from 'redux-thunk';

import { reducers } from '../../reducers';
import children from '../../routes';

// tslint:disable-next-line:no-string-literal
const devToolsExtension: GenericStoreEnhancer = window['devToolsExtension'] ?
  // tslint:disable-next-line:no-string-literal
  window['devToolsExtension']() : (f: any) => f;

const store = createStore(reducers,
  compose(
    applyMiddleware(thunk),
    devToolsExtension
  ) as GenericStoreEnhancer
);

const basename = process.env.NODE_ENV === 'production' ? '/licensing' : undefined;

export default function AppContainer() {
  return (
    <Provider {...{ store }}>
      <Router {...{ basename, children }} />
    </Provider>
  );
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/app/AppContainer.tsx